<script setup lang="ts">
// Replaces the legacy loader.gif / loading-dot. Indeterminate; optional label slot.
import type { UiSize } from '@/shared/ui/types'

withDefaults(defineProps<{ size?: UiSize }>(), { size: 'md' })

const ringSizeClasses = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-7 w-7 border-[3px]',
  xl: 'h-10 w-10 border-[3px]',
} as const
</script>

<template>
  <span
    class="ui-spinner inline-flex items-center gap-xs text-muted font-sans"
    :class="`ui-spinner--${size}`"
    role="status"
  >
    <span
      class="ui-spinner__ring rounded-full border-2 border-current border-r-transparent animate-spin"
      :class="ringSizeClasses[size]"
      aria-hidden="true"
    />
    <span v-if="$slots.default" class="ui-spinner__label text-[0.8125rem]"><slot /></span>
  </span>
</template>
